import React from 'react';

import { IntlManager } from '@atlas/core';
import { Label } from '@atlas/ui';

const PaymentMethodInfo = ({ selectedMethod }) => {
  if (!selectedMethod) {
    return null;
  }

  return (
    <div className="one-step-deposit__payment-info">
      <span className="one-step-deposit__payment-info-name">
        <Label message="pay_via" /> <span>{selectedMethod.name}:</span>
      </span>

      <span className="one-step-deposit__payment-info-group">
        <span className="one-step-deposit__payment-info-label">
          <Label message="min_amount" />
        </span>
        <span className="one-step-deposit__payment-info-value">
          {IntlManager.formatMoney(selectedMethod.minAmount)}
        </span>
      </span>

      <span className="one-step-deposit__payment-info-separator">-</span>

      <span className="one-step-deposit__payment-info-group">
        <span className="one-step-deposit__payment-info-label">
          <Label message="max_amount" />
        </span>
        <span className="one-step-deposit__payment-info-value">
          {IntlManager.formatMoney(selectedMethod.maxAmount)}
        </span>
      </span>
    </div>
  );
};

export default PaymentMethodInfo;
